import fetch from "@/plugin/axios"

//类型列表分页
export function list(query) {
  return fetch({
    url: "/admin/classes/page",
    method: "get",
    params: query
  })
}
//类型添加
export function saveOrUpdate(obj) {
  return fetch({
    url: "/admin/classes/saveOrUpdate",
    method: "post",
    data: obj
  })
}
